import styled from 'styled-components'
import { themeGet } from 'styled-system'

export const StyledContainer = styled.div`
  align-items: center;
  background-color: #eef0f2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0.875rem 0 1.125rem;
  text-align: center;
  width: 100%;

  @media only screen and (max-width: 768px) {
    .yield-icon {
      height: 61px;
      width: 70px;
    }
  }

  @media only screen and (max-width: 600px) {
    padding: 1.5rem 0 1.75rem;
  }
`

export const ContentWrapper = styled.div`
  ${themeGet('breakpoints.tablet')} {
    padding: 0;
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 3.125rem;
  margin-bottom: 2.75rem;

  button {
    &:not(:last-of-type) {
      margin-right: 1rem;
    }
  }

  @media only screen and (max-width: 768px) {
    margin-top: 2.125rem;
    margin-bottom: 3.5rem;
  }

  @media only screen and (max-width: 600px) {
    margin-top: 2rem;
  }
`

export const Header = styled.h1`
  color: #002855;
  font-family: SharpSlab-Bold;
  font-size: 2.625rem;
  line-height: 3.4375rem;
  margin: 3.25rem 0 0.5rem;
  text-align: center;

  @media only screen and (max-width: 768px) {
    font-size: 1.625rem;
    margin-top: 1.5rem;
    margin-bottom: 0;
  }

  @media only screen and (max-width: 600px) {
    letter: 0.0406rem;
    line-height: 2.125rem;
    margin-top: 1.875rem;
    margin-bottom: 0.625rem;
  }
`

export const SubHeader = styled.h2`
  color: #002855;
  font-family: SharpSlab-Medium;
  font-size: 2.625rem;
  margin: 0;
  text-align: center;

  @media only screen and (max-width: 768px) {
    font-size: 1.625rem;
    margin-top: 0.25rem;
    padding: 0 2rem 0;
  }

  @media only screen and (max-width: 600px) {
    letter: 0.0406rem;
    line-height: 2.125rem;
    margin-top: 0.75rem;
  }
`

export const StyledBodyCopy = styled.span`
  color: #555555;
  font-family: ${themeGet('fontFamily')};
  font-size: 1rem;
  margin-bottom: 0.5rem;
  padding: 0.5rem 0;

  ${themeGet('breakpoints.tablet')} {
    padding: 0.5rem 0;
  }
`

export const LogOutButton = styled.button`
  background-color: #3c6e90;
  border: 0;
  border-radius: 0.3125rem;
  color: #ffffff;
  padding: 0.625rem 4.875rem 0.625rem 4.8125rem;
  text-transform: capitalize;

  &:hover {
    background-color: #002855;
    border-color: #002855;
  }

  &:focus {
    background-color: #002855;
    border-color: #002855;
  }
`



// WEBPACK FOOTER //
// ./src/components/AuthZeroErrorMessage/component.styles.js